import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * A simple table component.
 *
 * @remark
 * This component change Detection has been defined as Default on purpose!
 * Setting onPush would force use to write custom code to handle when
 * the change detection should kick in. Since this is a super simple component,
 * there is no need to go through this effort as it's unlikely to have side effects
 *
 * The expectation is that when the input changes, the change detection should kick in
 */
@Component({
  selector: 'nibtravel-table',
  templateUrl: './table.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class TableComponent {
  @Input() table!: { tableData: unknown[][] };

  get tableData(): unknown[][] {
    return this.table?.tableData;
  }
}
